import React from "react";
import "react-slideshow-image/dist/styles.css";
import "./ProjectsPage.css";
import { Slide } from "react-slideshow-image";
import image101 from "../../assets/image10-1.jpeg";
import image102 from "../../assets/image10-2.jpeg";
import image91 from "../../assets/image9-1.jpeg";
import image92 from "../../assets/image9-2.jpeg";
import image81 from "../../assets/image8-1.jpeg";
import image82 from "../../assets/image8-2.jpeg";
import image71 from "../../assets/image7-1.jpeg";
import image72 from "../../assets/image7-2.jpeg";
import image61 from "../../assets/image6-1.jpeg";
import image62 from "../../assets/image6-2.jpeg";
import image63 from "../../assets/image6-3.jpeg";
import image64 from "../../assets/image6-4.jpeg";
import image51 from "../../assets/image5-1.jpeg";
import image52 from "../../assets/image5-2.jpeg";
import image53 from "../../assets/image5-3.jpeg";
import image54 from "../../assets/image5-4.jpeg";
import image55 from "../../assets/image5-5.jpeg";
import image56 from "../../assets/image5-6.jpeg";
import image57 from "../../assets/image5-7.jpeg";
import image41 from "../../assets/image41.jpeg";
import image42 from "../../assets/image42.jpeg";
import image43 from "../../assets/image43.jpeg";
import image44 from "../../assets/image44.jpeg";
import image45 from "../../assets/image45.jpeg";
import image46 from "../../assets/image46.jpeg";
import image47 from "../../assets/image47.jpeg";
import image31 from "../../assets/image31.jpeg";
import image32 from "../../assets/image32.jpeg";
import image33 from "../../assets/image33.jpeg";
import image34 from "../../assets/image34.jpeg";
import image35 from "../../assets/image35.jpeg";
import image11 from "../../assets/image11.jpeg";
import image12 from "../../assets/image12.jpeg";
import image13 from "../../assets/image13.jpeg";
import image14 from "../../assets/image14.jpeg";
import image15 from "../../assets/image15.jpeg";
import image16 from "../../assets/image16.jpeg";
import image17 from "../../assets/image17.jpeg";
import h44370 from "../../assets/h4437/44370.jpeg";
import h44371 from "../../assets/h4437/44371.jpeg";
import h44372 from "../../assets/h4437/44372.jpeg";
import h44373 from "../../assets/h4437/44373.jpeg";
import h44374 from "../../assets/h4437/44374.jpeg";
import h44375 from "../../assets/h4437/44375.jpeg";
import h44376 from "../../assets/h4437/44376.jpeg";
import h44377 from "../../assets/h4437/44377.jpeg";
import h44378 from "../../assets/h4437/44378.jpeg";
import h44379 from "../../assets/h4437/44379.jpeg";
import h443710 from "../../assets/h4437/443710.jpeg";
import h443711 from "../../assets/h4437/443711.jpeg";
import h45380 from "../../assets/h4538/45380.jpeg";
import h45381 from "../../assets/h4538/45381.jpeg";
import h45382 from "../../assets/h4538/45382.jpeg";
import h45383 from "../../assets/h4538/45383.jpeg";
import h45384 from "../../assets/h4538/45384.jpeg";
import h45385 from "../../assets/h4538/45385.jpeg";
import h45386 from "../../assets/h4538/45386.jpeg";
import h45387 from "../../assets/h4538/45387.jpeg";
import h12720 from "../../assets/h1272/12720.jpeg";
import h12721 from "../../assets/h1272/12721.jpeg";
import h12722 from "../../assets/h1272/12722.jpeg";
import h12723 from "../../assets/h1272/12723.jpeg";
import h12724 from "../../assets/h1272/12724.jpeg";
import h12725 from "../../assets/h1272/12725.jpeg";
import h12726 from "../../assets/h1272/12726.jpeg";
import h12727 from "../../assets/h1272/12727.jpeg";
import h12728 from "../../assets/h1272/12728.jpeg";
import h12729 from "../../assets/h1272/12729.jpeg";
import h127210 from "../../assets/h1272/127210.jpeg";
import h127211 from "../../assets/h1272/127211.jpeg";
import h127212 from "../../assets/h1272/127212.jpeg";
import h127213 from "../../assets/h1272/127213.jpeg";

export const ProjectsPage = () => {
  return (
    <div style={{ backgroundColor: "#F9F9F9" }}>

      <div id="projectPage">
        <h1 id="titlePr">PROJECTS</h1>
        <div id="firstProject">   <Slide>
          {[
            h12721,
            h12722,
            h12723,
            h12724,
            h12725,
            h12726,
            h12727,
            h12728,
            h12729,
            h127210,
            h127211,
            h127212,
            h127213,
            h12720
          ].map((img, i) => (
            <div className="each-slide-effect" key={i}>
              <div
                style={{
                  backgroundImage: `url(${img})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          ))}
        </Slide>
        </div>

        <Slide>
          {[h45380, h45381, h45382, h45383, h45384, h45385, h45386, h45387].map(
            (img, index) => (
              <div className="each-slide-effect" key={index}>
                <div style={{ backgroundImage: `url(${img})` }}></div>
              </div>
            )
          )}
        </Slide>        <div id="slide2">

        <Slide>
  {[
    h44370,
    h44372,
    h44373,
    h44374,
    h44375,
    h44376,
    h44377,
    h44378,
    h44379,
    h443710,
    h443711,
  ].map((img, i) => (
    <div className="each-slide-effect" key={i}>
      <div
        style={{
          backgroundImage: `url(${img})`,
          backgroundPosition: "center",
        }}
      ></div>
    </div>
  ))}
</Slide>

        </div>

        <Slide>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image11})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image12})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image13})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image14})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image15})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image16})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
          <div className="each-slide-effect">
            <div
              style={{
                backgroundImage: `url(${image17})`,
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        </Slide>
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image31})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image32})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image33})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image34})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image35})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image41})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image42})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image43})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image44})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image45})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image46})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image47})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image51})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image52})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image53})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image54})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image56})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image55})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image57})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image61})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image62})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image63})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image64})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>{" "}
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image71})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image72})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>{" "}
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image81})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image82})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>{" "}
        <div id="slide2">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image91})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image92})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>{" "}
        <div className="lastProject">
          <Slide>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundPosition: "center",
                  backgroundImage: `url(${image101})`,
                }}
              ></div>
            </div>
            <div className="each-slide-effect">
              <div
                style={{
                  backgroundImage: `url(${image102})`,
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </Slide>
        </div>{" "}
      </div>    </div>

  );
};
